module.exports = __webpack_public_path__ + "img/arrowBack.04e4bc1b.svg";